import { createEffect } from 'effector';
import { api } from '../../api/axiosinstance.js';

export const getUserFx = createEffect().use(async (id) => {
  return (await api(true).get(`users/${id}`)).data;
});
